import { routes } from "../config/storefront.js";

export function normalizePath(path) {
  if (!path || path === "") return "/";
  const withoutQuery = path.split("?")[0].split("#")[0];
  if (withoutQuery === "/") return "/";
  return withoutQuery.endsWith("/") ? withoutQuery : `${withoutQuery}/`;
}

export function currentRoutePath() {
  const path = normalizePath(window.location.pathname);
  return routes[path] ? path : path;
}

export function isKnownRoute(path) {
  return Boolean(routes[normalizePath(path)]);
}
